import Title from '@/components/ui/Title'

const ALastEden = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="A Final Eden" />
      <p className="text-3xl leading-12 md:px-16">
        This production was my first project in Unreal Engine using animation
        and sequencer capture. Using a character that I modelled in ZBrush and
        textured in Substance Painter, I captured a short story aboard a
        mysterious train. The concept here was to create an eerie, unsettling
        environment around the train, as if we the observers are witnessing
        something we aren’t supposed to. The train serves as a last conservation
        of nature within a barren, lifeless world, attended by the last nature
        spirit living on the planet. This project incorporated a lot of lighting
        and Niagara system use to enhance the animation and storytelling.
      </p>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="A Final Eden"
          src="https://www.youtube.com/embed/9vUCLnJWqp4"
        />
      </div>
    </div>
  )
}

export default ALastEden
